import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { MobilemenuCollectionCatagoryMapping, MobilemenuCollectionCatagoryMappingAddEdit } from './Pages';

export const MobilemenuCollectionCatagoryMappingRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={MobilemenuCollectionCatagoryMapping} />
        <Route exact path = {`${match.path}/AddEdit`} component={MobilemenuCollectionCatagoryMappingAddEdit} />
    </Fragment>
)